import GrimoireInterface from "../Interface/GrimoireInterface";
import NSIdentity from "./NSIdentity";
// import Namespace from "./Namespace";
import NSDictionary from "./NSDictionary";
import ComponentDeclaration from "../Node/ComponentDeclaration";
/**
 * Provides static methods to ensure arguments are valid type.
 */
export default class Ensure {
    static tobeComponentIdentity(component) {
        if (typeof component === "function") {
            const obj = ComponentDeclaration.ctorMap.find(o => o.ctor === component);
            if (obj) {
                component = obj.name;
            }
            else {
                throw new Error(`Specified constructor have not registered to current context.`);
            }
        }
        else {
            component = Ensure.tobeNSIdentity(component);
        }
        return component;
    }
    /**
     * Ensure specified str being string
     * @param  {string | number}      str [description]
     * @return {string}      [description]
     */
    static tobeString(str) {
        if (typeof str === "string") {
            return str;
        }
        else if (typeof str === "number") {
            return str.toString();
        }
        else {
            throw new Error("Specified argument can not convert into string");
        }
    }
    /**
     * Ensure specified number being number
     * @param  {string | number}      str [description]
     * @return {string}      [description]
     */
    static tobeNumber(num) {
        if (typeof num === "string") {
            return parseInt(num, 10);
        }
        else if (typeof num === "number") {
            return num;
        }
        else {
            throw new Error("specified argument can not be converted into number");
        }
    }
    /**
     * string or NSIdentity ensure to be NSIdentity.
     * @param  {Name}       name [description]
     * @return {NSIdentity}      [description]
     */
    static tobeNSIdentity(name) {
        if (!name) {
            throw Error(`argument can not be null or undefined.`);
        }
        if (typeof name === "string") {
            return NSIdentity.guess(name);
        }
        else {
            return name;
        }
    }
    static tobeNSIdentityArray(names) {
        if (!names) {
            return [];
        }
        const newArr = [];
        for (let i = 0; i < names.length; i++) {
            newArr.push(this.tobeNSIdentity(names[i]));
        }
        return newArr;
    }
    static tobeNSDictionary(dict) {
        if (!dict) {
            return new NSDictionary();
        }
        if (dict instanceof NSDictionary) {
            return dict;
        }
        else {
            const newDict = new NSDictionary();
            for (let key in dict) {
                newDict.set(NSIdentity.guess(key), dict[key]);
            }
            return newDict;
        }
    }
    static tobeMessage(message) {
        if (message.startsWith("$")) {
            if (message.startsWith("$$")) {
                return message;
            }
            else {
                return "$" + message;
            }
        }
        else {
            return "$$" + message;
        }
    }
    /**
     * string, NSIdentity or constructor ensure to be constructor.
     * return null if identity is not registered as component.
     * @param  {[type]} typeofc==="function" [description]
     * @return {[type]}                      [description]
     */
    static tobeComponentConstructor(c) {
        if (typeof c === "function") {
            return c;
        }
        else {
            const dec = GrimoireInterface.componentDeclarations.get(c);
            if (dec) {
                return dec.ctor;
            }
            return null;
        }
    }
    static tobeFQN(name) {
        if (typeof name === "string") {
            if (Ensure.checkFQNString(name)) {
                return name.substring(1);
            }
            return null;
        }
        else {
            return name.fqn;
        }
    }
    static checkFQNString(name) {
        return name.startsWith("_");
    }
}



// WEBPACK FOOTER //
// ./src/Base/Ensure.ts